















import { defineComponent, PropType } from "@vue/composition-api";
import { ListField } from "@/types";
import BaseCheckbox from "@/components/BaseCheckbox";

export default defineComponent({
  name: "BaseCheckChip",
  components: { BaseCheckbox },
  props: {
    field: { type: Object as PropType<ListField>, required: true },
    value: { type: Boolean, default: false },
  },
});
